import { CSP_NONCE, Component, Inject, Injectable } from '@angular/core';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Meta } from '@angular/platform-browser';
@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Elementos por página';
  override nextPageLabel = 'Siguiente';
  override previousPageLabel = 'Anterior';
  override firstPageLabel = 'Primera página';
  override lastPageLabel = 'Última página';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex = startIndex < length
      ? Math.min(startIndex + pageSize, length)
      : startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} de ${length}`;
  };
}
@Injectable()
export class FirstDayIntlService extends NativeDateAdapter {
    override getFirstDayOfWeek(): number {
        return 1;
    }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'frontend.angular';

  constructor(private meta: Meta, private dateAdapter: DateAdapter<Date>, @Inject(CSP_NONCE) private cspNonce: string) {
    //META-TAGS
    /*this.meta.addTags([
      { name: 'keywords', content: 'angular, javascript, typescript, meta, seo' },
      { name: 'Strict-Transport-Security', content: 'max-age=31536000; includeSubDomains' },
      { name: "X-Content-Type-Options", content: "nosniff"}
    ]);*/
    
     // Configurar el idioma a españolfechaActual
    this.dateAdapter.setLocale('es-ES');

  }

}
